export const initState = {
	fetchAll: {
		from: 1,
		size: 10,
		total: 0,

		_list: 'init',
		$list: [],
	},

	addTurn: {
		_add: 'init',

		show: false,

		time: null,
		date: null,
	},

	editTurn: {
		_edit: 'init',

		show: false,

		id: '',

		date: null,
		time: null,
	},

	infoUser: {
		_info: 'init',
		info: null,

		show: false,

		id: '',
		isAttempted: null,
	},

	removeUser: {
		_remove: 'init',

		show: false,

		id: '',
	},

	removeTurn: {
		_remove: 'init',

		show: false,

		id: '',
	},
};

export default initState;
